import { useState } from "react";
import { Modal } from "react-bootstrap";

const EditAOIModal = (props) => {
    const [aoiName, setAoiName] = useState(props.aoiToEdit?.name ?? '');
    const [alertMgs, setAlertMgs] = useState('');

    const saveAOIDetails = () => {
        if (!aoiName) {
            setAlertMgs("Enter a Valid AOI Name");
        }
        else {
            props.setShowAOIEditModal(false);
            props.onConfirmEditAOI(true, aoiName);
        }
    }

    const onCancel = () => {
        props.setShowAOIEditModal(false);
        props.onCancel();
    }

    return (
        <Modal
            show={() => props.setShowAOIEditModal(true)}
            onHide={onCancel}
            backdrop="static"
            keyboard={false}
            size='md'
            dialogClassName="edit-aoi-confirm-modal-dialog"
            className="edit-aoi-confirm-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title>Edit AOI</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="form-group">
                    <label className="form-label" htmlFor="edit-aoi-label">AOI Name :</label>
                    <input type="text" className="form-control" value={aoiName} onInput={e => setAoiName(e.target.value)}/>
                    
                    <div className="edit-aoi-alert-mgs"><span>{ !!alertMgs && alertMgs }</span></div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="btn-area">
                    <a onClick={onCancel} className="btn btn-text">Cancel</a>
                    <button type="button" className="btn btn-primary" aria-label="Submit" onClick={saveAOIDetails} disabled={!aoiName}>
                        Save
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export default EditAOIModal;